import type { FlatDrawers, Drawer } from '@virtuslab/nfs-shared/src/schema/user/drawerModels';
import type { Nullable } from '@virtuslab/nfs-shared/src/services/object';

import { toTree } from '..';

const queryResolver = (drawers: FlatDrawers): Nullable<Drawer> => toTree(drawers);

export default queryResolver;
